import { AsyncPipe, JsonPipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation, ViewRef } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData, MediaComponent } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { StorageService } from 'src/app/service/storage/storage.service';
import { RemoveImageTitleAttrDirective } from '../../../../shared/remove-title-attr.directive';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../asm/asm-constant';

@Component({
  selector: 'app-login-footer',
  templateUrl: './login-footer.component.html',
  styleUrls: ['./login-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MediaComponent, RemoveImageTitleAttrDirective, AsyncPipe, JsonPipe],
})
export class LoginFooterComponent implements OnInit, OnDestroy {
  data$: Observable<any> = this.componentData.data$;
  imageUrls: string[];
  hasRequested = 'false';
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);

  label: string;
  phoneNumber: string;
  email: string;
  imageLinks: any[];

  loginFooterSubscription: Subscription;

  @HostBinding('style.display') 
  get display(): string {
    return this.hasRequested === 'true'? 'none' : 'block';
  }

  constructor(
    protected componentData: CmsComponentData<any>,
    protected cmsService: CmsService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    if (this.f === 'true') {
      this.hasRequested = this.f;
    }

    // force GET data$ onChange of currentPage
    this.loginFooterSubscription = this.data$.subscribe((data) => {
      if (data !== null) {
        this.data$ = of(data);
        if (data.imageLinks !== undefined) {
          this.getTest();
        }
      }
    });
  }

  getTest() {
    this.data$
      .pipe(
        take(1),
        switchMap((data) =>
          combineLatest(
            data.imageLinks
              .split(' ')
              .map((uid: string) => this.cmsService.getComponentData<any>(uid).pipe(map((d) => ({ ...d }))))
          )
        )
      )
      .subscribe((links: any) => {
        const hasObjectEmpty = links
          .map((data: any) => Object.keys(data).length <= 0)
          .filter((empty: any) => empty === true).length;
        if (links !== null && hasObjectEmpty < 1) {
          this.imageLinks = links;
        }
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      });
  }
  get f() {
    return this.storageService.getLocalStorageItem('hasRequested');
  }

  ngOnDestroy() {
    if (this.loginFooterSubscription) this.loginFooterSubscription.unsubscribe;
  }
}
